import usuarioList from './list';
import usuarioEdit from './edit';
import usuarioCreate from './create';
export default {
    list : usuarioList,
    edit : usuarioEdit, 
    create : usuarioCreate
}
